export interface RefreshMutex {
  run<T>(work: () => Promise<T>): Promise<T>;
}

export const browserRefreshMutex: RefreshMutex = {
  run(work) {
    if (typeof navigator !== "undefined" && navigator.locks?.request) {
      return navigator.locks.request("workflow-auth-refresh", work);
    }
    return work();
  },
};
